import { useState, useCallback } from 'react';
import webStorage from '../utils/webStorage';

const usePersistedState = <State>(
    key: string,
    defaultState?: State,
): [State, (newState: State) => void] => {
    const [state, setState] = useState(webStorage.getItemParsed(key) || defaultState);

    const updateState = useCallback((newState: State) => {
        setState(newState);
        webStorage.setItemParsed(key, newState);
    }, []);

    return [state, updateState];
};

export default usePersistedState;
